module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter4"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch4"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_c('strong', [_vm._v("DULCE DE LECHE")]), _vm._v(" BREAD PUDDING")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SERVES 8 TO 10")])]), _vm._v(" "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "images/img-014.jpg"
    }
  }), _vm._v(" Texas’s undisputed melting pot is Houston, where native Texans, Native Americans, Latin Americans, African Americans, Caribbean peoples, Vietnamese, Southerners, Yanks, and millions of others commingle culinarily with finesse. Here’s an example of a cumulative creation, in this case featuring a lively mix of south Louisiana’s liquored-up bread puddings, Latin America’s rich dulce de leche, and the Caribbean’s zippy rum. And when all this collides with vanilla bean ice cream? "), _c('em', [_vm._v("C’est si bueno, mon.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_c('span', {
    staticClass: "cc"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("DULCE DE LECHE SAUCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 cups heavy whipping cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("3 cups packed dark brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cups sweetened condensed milk")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_c('span', {
    staticClass: "cc"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BREAD PUDDING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Eight ½-inch-thick slices rich egg bread (such as challah, Hawaiian-style, or croissants), crust trimmed, cut into 1-inch cubes (about 10 cups)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 tablespoons (½ stick) unsalted butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cups heavy whipping cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("4 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 egg yolks")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("3 tablespoons amber or dark rum")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("8")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("½ cup caramel bits or butterscotch chips")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 tablespoons light brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("¼ cup powdered sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("TO MAKE THE DULCE DE LECHE SAUCE:")])])]), _vm._v(" In a medium, heavybottom saucepan, combine the cream and sugar and stir over medium heat until the sugar dissolves. Gently boil the mixture until it reduces in volume by one-third, stirring occasionally, for 5 to 7 minutes. Stir in the condensed milk. Cover and refrigerate for at least 3 hours to ensure that the flavors meld.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("TO MAKE THE BREAD PUDDING:")])])]), _vm._v(" Preheat the oven to 350°F.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PUT")])]), _vm._v(" the bread cubes in a large bowl. Add 3 tablespoons of the melted butter to the bread; toss to evenly coat. Transfer the buttered bread to a baking sheet and bake until it begins to turn golden, 10 to 12 minutes. Remove from the oven and let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("COAT")])]), _vm._v(" an 11-×-7-inch glass baking dish with the remaining 1 tablespoon butter and set aside. (Note: Glass dishes help you see how quickly a dish is browning.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])]), _vm._v(" a medium, heavy-bottom saucepan, combine the cream with 1 cup of the dulce de leche sauce and stir over medium heat until it just begins to bubble. Remove from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])]), _vm._v(" a large bowl, whisk the eggs and egg yolks. Add the rum, vanilla, and salt. Slowly incorporate the warm dulce de leche-cream mixture. Fold in the bread cubes and refrigerate for about 30 minutes, gently stirring occasionally.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAREFULLY")])]), _vm._v(" fold the caramel bits into the chilled bread pudding mixture, so that the bread holds as much of its shape as possible. Transfer this final mixture into the prepared baking dish and sprinkle with the brown sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BAKE")])]), _vm._v(" for about 30 minutes, or until the mixture is set in the middle. Allow it to cool on a wire rack for 10 to 15 minutes and then dust with the powdered sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])]), _vm._v(" a medium saucepan, slowly warm the remaining dulce de leche sauce over medium-low heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CUT")])]), _vm._v(" the bread pudding into squares and serve warm with dulce de leche sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space2"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("SWEET TALK")])]), _vm._v(" Latin-cooking purists know that true dulce de leche (meaning “sweet milk”) is made with milk, sugar, vanilla, and baking soda–and takes hours of slow cooking to condense to impeccable richness. This version, however, saves loads of time and is equally delicious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Use any leftover sauce on ice cream or atop fruit or cake. Or better yet, double the amount of sauce to ensure you can do just that.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aafa356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011chapter4.vue
// module id = 87
// module chunks = 0